import './DeviceRequest.css'
import { Button } from '@mui/material'
// Components
import IonicPageWrapper from '../../components/IonicPageWrapper/IonicPageWrapper'
import LiveStreamModal from '../../components/LiveStreamModal/LiveStreamModal';
// ICONs & SVGs
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import VideocamIcon from '@mui/icons-material/Videocam';
import lightIcon from '../../imgs/light_img.svg'

import IconButton from '@mui/material/IconButton';
import CircleIcon from '@mui/icons-material/Circle';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from "axios";
import { useSnackbar } from "notistack";
import { useHistory } from 'react-router';

function DeviceRequest() {
    const { cam_id } = useParams();
    const user_id = localStorage.getItem("user_id");
    const auth = localStorage.getItem("authToken");
    const history = useHistory();
    const isloggedin = localStorage.getItem("loggedIn");

    const [streamModalOpen, setStreamModalOpen] = useState(false);

    useEffect(() => {
        if (!isloggedin) {
            history.push('/login');
            window.location.reload();
        }
    }, []);

    const onBackClick = () => {
        history.goBack();
    }

    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);
    const [led_r, setLed_r] = useState('OFF');
    const [led_g, setLed_g] = useState('OFF');
    const [led_y, setLed_y] = useState('OFF');
    const [led_w, setLed_w] = useState('OFF');
    const [allDevices, setAllDevices] = useState({});

    // Smartlight Group Request support
    const [requestMode, setRequestMode] = useState('single'); // 'single' or 'group'
    const [groupsList, setGroupsList] = useState([]);
    const [selectedGroupId, setSelectedGroupId] = useState('');

    useEffect(() => {
        setAllDevices({});
        fetchAllDevices(false);
        fetchGroups();
        const interval = setInterval(() => {
            fetchAllDevices(true);
        }, 2500);
        return () => clearInterval(interval);
    }, [cam_id]);

    const fetchGroups = async () => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/admin/groups/all`, { user_id }, {
                headers: { Authorization: `Bearer ${auth}` }
            });
            if (res.data?.success && Array.isArray(res.data.groups)) {
                setGroupsList(res.data.groups);
                if (res.data.groups.length > 0) {
                    setSelectedGroupId(String(res.data.groups[0].group_id));
                }
            }
        } catch (err) {
            console.error('Error fetching groups in user app:', err);
        }
    };

    const fetchAllDevices = async (isSilent = false) => {
        if (!isSilent) setLoading(true);
        await axios.post(`${process.env.REACT_APP_BASE_URL}/admin/users/getsubdatabycamid`, { cam_id })
            .then(res => {
                if (!res.data?.success) {
                    if (!isSilent) enqueueSnackbar('No Device Found !!!', { variant: 'error' });
                    return;
                }
                setAllDevices(res.data.data);
                if (!isSilent) {
                    const subObj = res.data.data?.data || {};
                    setLed_r(subObj.RED_LED || subObj.LED_R || 'OFF');
                    setLed_g(subObj.GREEN_LED || subObj.LED_G || 'OFF');
                    setLed_y(subObj.YELLOW_LED || subObj.LED_Y || 'OFF');
                    setLed_w(subObj.WHITE_LED || subObj.LED_W || 'OFF');
                }
            })
            .catch(err => {
                console.log(err);
                if (!isSilent) enqueueSnackbar('Error Fetching Devices !!!', { variant: 'error' });
            })
            .finally(() => {
                if (!isSilent) setLoading(false);
            });
    }

    const sendRequest = async () => {
        setLoading(true);
        const isGroup = requestMode === 'group';
        const payload = {
            ...(isGroup ? { group_id: selectedGroupId } : { cam_id: cam_id }),
            RED_LED: led_r,
            GREEN_LED: led_g,
            WHITE_LED: led_w,
            YELLOW_LED: led_y,
            ledr: led_r,
            ledg: led_g,
            ledw: led_w,
            ledy: led_y,
            state: 'Request',
            user_id: user_id
        };
        try {
            const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/admin/users/senddata`, payload, {
                headers: { Authorization: `Bearer ${auth}` }
            });
            if (!response.data?.success) {
                enqueueSnackbar(response.data?.message || 'No Device Found !!!', { variant: 'error' });
            } else {
                if (isGroup) {
                    const foundGrp = groupsList.find(g => String(g.group_id) === String(selectedGroupId));
                    enqueueSnackbar(`Request Sent to All Smartlights in Group "${foundGrp?.group_name || ''}"!`, { variant: 'success' });
                } else {
                    enqueueSnackbar('Request Sent Successfully !!!', { variant: 'success' });
                }
                setTimeout(() => window.location.reload(), 1000);
            }
        } catch (error) {
            console.log(error);
            enqueueSnackbar('Error Sending Request !!!', { variant: 'error' });
        } finally {
            setLoading(false);
        }
    }

    const handleToggleLedRed = () => {
        setLed_r(led_r === 'OFF' ? 'ON' : 'OFF');
    };
    const handleToggleLedGreen = () => {
        setLed_g(led_g === 'OFF' ? 'ON' : 'OFF');
    };
    const handleToggleLedYellow = () => {
        setLed_y(led_y === 'OFF' ? 'ON' : 'OFF');
    };
    const handleToggleLedWhite = () => {
        setLed_w(led_w === 'OFF' ? 'ON' : 'OFF');
    };
    const handleToggleAll = () => {
        const anyOn = led_r === 'ON' || led_g === 'ON' || led_y === 'ON' || led_w === 'ON';
        const nextState = anyOn ? 'OFF' : 'ON';
        setLed_r(nextState);
        setLed_g(nextState);
        setLed_y(nextState);
        setLed_w(nextState);
    };

    const subObj = allDevices?.data || {};
    const isMotion = subObj.event === 'motion_detected' || subObj.status === 'active' || subObj.motion_detected === true;

    return (
        <IonicPageWrapper onBackClick={onBackClick} headerTitle='Device' showLogout={true}>
            <div id="lightsRequestControl">
                <div className="lightsRequestControl_cardCont">
                    {Object.keys(allDevices).length > 0 ? (
                        <>
                            {/* Target Mode: Single vs Group */}
                            <div style={{ display: 'flex', gap: '8px', marginBottom: '14px', width: '100%', maxWidth: '360px' }}>
                                <button
                                    type="button"
                                    onClick={() => setRequestMode('single')}
                                    style={{
                                        flex: 1,
                                        padding: '8px 12px',
                                        borderRadius: '8px',
                                        border: requestMode === 'single' ? '2px solid #1976d2' : '1px solid #ccc',
                                        backgroundColor: requestMode === 'single' ? '#e3f2fd' : '#fff',
                                        color: requestMode === 'single' ? '#1565c0' : '#666',
                                        fontWeight: 'bold',
                                        cursor: 'pointer'
                                    }}
                                >
                                    💡 Single #{cam_id}
                                </button>
                                <button
                                    type="button"
                                    onClick={() => setRequestMode('group')}
                                    style={{
                                        flex: 1,
                                        padding: '8px 12px',
                                        borderRadius: '8px',
                                        border: requestMode === 'group' ? '2px solid #1976d2' : '1px solid #ccc',
                                        backgroundColor: requestMode === 'group' ? '#e3f2fd' : '#fff',
                                        color: requestMode === 'group' ? '#1565c0' : '#666',
                                        fontWeight: 'bold',
                                        cursor: 'pointer'
                                    }}
                                >
                                    👥 Smartlight Group
                                </button>
                            </div>

                            {requestMode === 'group' && (
                                <div style={{ width: '100%', maxWidth: '360px', marginBottom: '14px', padding: '12px', backgroundColor: '#f5f7fa', borderRadius: '10px', border: '1px solid #e0e0e0' }}>
                                    <label style={{ fontSize: '12px', fontWeight: 'bold', color: '#555', display: 'block', marginBottom: '6px' }}>
                                        Target Smartlight Group:
                                    </label>
                                    <select
                                        value={selectedGroupId}
                                        onChange={(e) => setSelectedGroupId(e.target.value)}
                                        style={{ width: '100%', padding: '8px 10px', borderRadius: '6px', border: '1px solid #bbb', backgroundColor: '#fff', fontSize: '14px' }}
                                    >
                                        {groupsList.map(grp => (
                                            <option key={grp.group_id} value={grp.group_id}>
                                                {grp.group_name} ({grp.device_count || (grp.devices ? grp.devices.length : 0)} lights)
                                            </option>
                                        ))}
                                    </select>
                                    <span style={{ fontSize: '11px', color: '#666', display: 'block', marginTop: '6px' }}>
                                        ✨ All smartlights in this group will receive this request simultaneously.
                                    </span>
                                </div>
                            )}

                            <div className="lights_card">
                                <section className='lights_card_content'>
                                    <img src={lightIcon} alt="" />
                                    <p className='lights_card_area'>
                                        {requestMode === 'group'
                                            ? (groupsList.find(g => String(g.group_id) === String(selectedGroupId))?.group_name || 'Group')
                                            : (allDevices?.cam_id || `Light #${cam_id}`)}
                                    </p>
                                </section>

                                <section className="lights_card_btnsCont">
                                    {/* Red LED */}
                                    <IconButton aria-label="red-led" size="small" onClick={handleToggleLedRed}>
                                        <CircleIcon fontSize="medium" sx={{ color: led_r === 'OFF' ? '#ff12004f !important' : '#ff1200 !important' }} />
                                    </IconButton>
                                    {/* Green LED */}
                                    <IconButton aria-label="green-led" size="small" onClick={handleToggleLedGreen}>
                                        <CircleIcon fontSize="medium" sx={{ color: led_g === 'OFF' ? '#00c8534f !important' : '#00c853 !important' }} />
                                    </IconButton>
                                    {/* Yellow LED */}
                                    <IconButton aria-label="yellow-led" size="small" onClick={handleToggleLedYellow}>
                                        <CircleIcon fontSize="medium" sx={{ color: led_y === 'OFF' ? '#ffff004f !important' : '#ffff00 !important' }} />
                                    </IconButton>
                                    {/* White LED */}
                                    <IconButton aria-label="white-led" size="small" onClick={handleToggleLedWhite}>
                                        <CircleIcon fontSize="medium" sx={{ color: led_w === 'OFF' ? '#ffffff4f !important' : '#fff !important' }} />
                                    </IconButton>
                                    {/* Toggle All */}
                                    <IconButton aria-label="power-all" size="small" onClick={handleToggleAll}>
                                        <PowerSettingsNewIcon fontSize="medium" sx={{ color: '#fff !important' }} />
                                    </IconButton>
                                </section>
                            </div>
                            <div style={{ display: 'flex', gap: '14px', marginTop: '10px', width: '100%', maxWidth: '360px' }}>
                                <Button
                                    variant='contained'
                                    startIcon={<VideocamIcon />}
                                    onClick={() => setStreamModalOpen(true)}
                                    sx={{
                                        flex: 1,
                                        backgroundColor: '#1976d2 !important',
                                        fontWeight: 'bold',
                                        padding: '10px 14px',
                                        borderRadius: '8px'
                                    }}
                                >
                                    Live Stream
                                </Button>
                                <Button
                                    variant='contained'
                                    onClick={sendRequest}
                                    disabled={loading}
                                    sx={{
                                        flex: 1,
                                        fontWeight: 'bold',
                                        padding: '10px 14px',
                                        borderRadius: '8px'
                                    }}
                                >
                                    {loading ? 'Sending...' : 'Send Request'}
                                </Button>
                            </div>
                        </>
                    ) : (
                        <p>Error In Loading Device</p>
                    )}
                </div>
            </div>

            <LiveStreamModal
                isOpen={streamModalOpen}
                onClose={() => setStreamModalOpen(false)}
                deviceId={cam_id}
                deviceName={allDevices?.cam_id || `Device ${cam_id}`}
            />
        </IonicPageWrapper>
    )
}

export default DeviceRequest